<template>
    <vs-row vs-justify="center" id="customers-box">
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-xs="12"
      >
        <!-- <vs-card>
          <vs-row class="w-25">
            <vs-col vs-w="10"></vs-col>
  
            <vs-col vs-w="2">
              <vs-button
                id="add-service-form"
                class="mr-2 w-100"
                icon="add"
                color="primary"
                @click="openAddCustomer()"
                >{{ $t("Reseller.AddResellerButton") }}</vs-button
              >
            </vs-col>
          </vs-row>
        </vs-card> -->
        <CustomizerSidebar
          ref="AddCustomer"
          @hide="hide"
          :reseller_new="true"
          :sideBarTitle="$t('Reseller.Add.Title')"
        ></CustomizerSidebar>
        <vs-card>
  
          <div slot="header">

          </div>

              <vs-table
                :sst="true"
                v-model="selected"
                :total="totalItems"
                max-items="10"  
                :data="requests"
              >
                <template slot="thead">
                  <vs-th sort-key="contactname">{{
                    $t("RequestTT.Table.CR")
                  }}</vs-th>
                  <vs-th sort-key="joindate">{{
                    $t("RequestTT.Table.CreatedAt")
                  }}</vs-th>
                  <vs-th sort-key="phone">{{ $t("RequestTT.Table.ExternalId") }}</vs-th>
                  <vs-th sort-key="phone">{{ $t("RequestTT.Table.Child") }}</vs-th>
                  <vs-th sort-key="book_id">{{
                    $t("RequestTT.Table.Status")
                  }}</vs-th>
                  <vs-th>{{ $t("Customer.Table.Options") }}</vs-th>
                </template>
  
                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].contract_resource">
                      <div class="d-flex no-block align-items-center">
                        <div class>
                          <h5 class="mb-0 font-16">
                            {{ data[indextr].contract_resource }}
                          </h5>
                        </div>
                      </div>
                    </vs-td>
  
                    <vs-td :data="data[indextr].created_at">
                      <div class="d-flex align-items-center">
                        {{ $moment(data[indextr].created_at).format('llll') }}
                      </div>
                    </vs-td>
  
                    <vs-td :data="data[indextr].external_id">
                      <div class="d-flex align-items-center">
                        {{ data[indextr].external_id }}
                      </div>
                    </vs-td>

                    <vs-td :data="data[indextr].child_not_delivered">
                    <div class="d-flex align-items-center">
                      <div v-if="data[indextr].child_not_delivered > 0" style="display: flex;">
                        <div :class="dotStyle ? 'pending-dot-red' : 'pending-dot-red pending-dot-white'"></div>
                      <span class="text-muted">{{ data[indextr].child_not_delivered }}</span>
                    </div>
                    <div style="display: flex;" v-else>
                      <span class="text-muted m-auto">{{ "--" }}</span>
                    </div>
                    </div>
                  </vs-td>
  
                    <vs-td :data="data[indextr].delivered">
                    <div class="d-flex align-items-center">
                      <div v-if="data[indextr].delivered == 0" style="display: flex;">
                        <div :class="dotStyle ? 'pending-dot-red' : 'pending-dot-red pending-dot-white'"></div>
                      <span class="text-muted">{{ $t("RequestTT.Pending") }}</span>
                    </div>
                    <div style="display: flex;" v-else>
                        <i class="mdi mdi-checkbox-marked-circle mr-2 display-8"></i>
                      <span class="text-muted m-auto">{{ $t("RequestTT.Delivered") }}</span>
                    </div>
                    </div>
                  </vs-td>
  
                    <vs-td>
                      <div class="btn-alignment">
                        <vs-button
                          radius
                          color="primary"
                          type="border"
                          icon="visibility"
                          @click="showRequest(data[indextr].id)"
                        ></vs-button>
                       
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-pagination
                @change="handleChangePage"
                :total="totalPages"
                v-model="currentPage"
              ></vs-pagination>
  
     
        </vs-card>
        <v-tour name="CustomersA" :steps="steps">
          <template slot-scope="tour">
            <transition name="fade">
              <v-step
                v-for="(step, index) of tour.steps"
                v-if="tour.currentStep === index"
                :key="index"
                :step="step"
                :previous-step="tour.previousStep"
                :next-step="tour.nextStep"
                :stop="tour.stop"
                :is-first="tour.isFirst"
                :is-last="tour.isLast"
                :labels="tour.labels"
              >
                <template v-if="tour.currentStep === 0">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="promptShow" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
                <template v-if="tour.currentStep === 1">
                  <div slot="actions" class="v-step__buttons">
                    <button @click="tour.previousStep" class="v-step__button">
                      Previous
                    </button>
                    <button @click="goToNextPage" class="v-step__button">
                      Next
                    </button>
                  </div>
                </template>
              </v-step>
            </transition>
          </template>
        </v-tour>
      </vs-col>
      <!---Show Sectet --->
      <vs-prompt
        color="success"
        :active.sync="createShowSecret"
        :title="$t('Kiosk.ShowSecretPrompt.Title')"
        :cancel-text="$t('Kiosk.ShowSecretPrompt.CancelButton')"
        buttonAccept="false"
      >
        <div>
          <div class="mb-4">
            <h4 class="font-weight-light">
              {{ $t("Kiosk.ShowSecretPrompt.Key") }}
            </h4>
            <h3 class="mt-2">{{ createKeyValue }}</h3>
          </div>
  
          <div class="mb-4">
            <h4 class="font-weight-light">
              {{ $t("Kiosk.ShowSecretPrompt.Secret") }}
            </h4>
            <h3 class="mt-2 mb-2">{{ createSecretValue }}</h3>
            <span class="text-danger mt-2">{{
              $t("Kiosk.ShowSecretPrompt.SecretSave")
            }}</span>
          </div>
        </div>
      </vs-prompt>
    </vs-row>
  </template>
  
  <script>
  import { requestTTService, resellerService } from "../../_services";
  import router from "../../_helpers/router";
  import CustomizerSidebar from "../../layout/full/customizer/CustomizerSidebar.vue";
  // moment
  
  export default {
    name: "Customers",
    data: () => ({
      createShowSecret: false,
      createSecretValue: "",
      createKeyValue: "",
      title: "Customers",
      activePrompt: false,
      activeDeletePrompt: false,
      activeUpdatePrompt: false,
      activeBookPrompt: false,
      activeUploadPrompt: false,
      activeApprovalPrompt: false,
      requests: [],
      approvedBusinesses: [],
      disapprovedBusinesses: [],
      selected: {},
      totalItems: 1,
      totalPages: 1,
      currentPage: 1,
      perPage: 10,
      totalApprovedPages: 0,
      currentApprovedPage: 1,
      totalDisapprovedPages: 0,
      currentDisapprovedPage: 1,
      maxItems: 0,
      importModal: {
        file: null,
      },
      steps: [
        {
          target: "#add-customer-form", // We're using document.querySelector() under the hood
          header: {
            title: "Get Started",
          },
          params: {
            placement: "right-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#edit-customer-button",
          params: {
            placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
      fname: "",
      lname: "",
      phone_number: "",
      address: "",
      email: "",
      notes: "",
      internalId: "",
      dateOfBirth: "",
      searchKeyword: "",
      current_page: 1,
      per_page: 10,
      _interval: null,
      dotStyle: true
    }),
    methods: {
      hide() {
        this.$emit("hide", "hide");
      },
      openAddCustomer() {
        this.$refs.AddCustomer.show();
      },
      Closed() {
        this.$vs.notify({
          color: "danger",
          title: "Delete Cancel",
          text: "Cancelling!",
        });
      },
      Canceled() {
        this.selected.approved = !this.selected.approved;
        this.$vs.notify({
          color: "danger",
          title: "Approval Cancel",
          text: "Cancelling!",
        });
      },
      updateReseller(id) {
        this.$router.push("/reseller/" + id + "/update");
      },

      notify(title, text, type) {
        this.$vs.notify({
          color: type,
          title: title,
          text: text,
        });
      },
      showLoading() {
        this.$vs.loading({
          container: "#customers-box",
          scale: 0.6,
        });
      },
      hideLoading() {
        this.$vs.loading.close("#customers-box > .con-vs-loading");
      },
      handleChangePage() {
        let query = `?current_page=${this.currentPage}&per_page=${this.perPage}`
        this.showLoading();
        requestTTService
        .getAll(query).then(
          function(res) {
            this.requests = res.data.data;
            this.totalItems = res.data.total;
            this.currentPage = res.data.current_page;
            this.totalPages = res.data.last_page;
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
          }.bind(this)
        );
      },
 
      close() {
        this.createShowSecret = false;
        this.createKeyValue = "";
        this.createSecretValue = "";
        this.promptData = {
          name: "",
          photo: "",
          theme: "liberrex",
          status: 1,
          queues: [],
        };
      },
      showRequest(request_id){
          this.$router.push('/request-tt/show/'+request_id);
        },
    toggleDot() {
        if(this.dotStyle) {
            this.dotStyle = false;
        } else {
            this.dotStyle = true;
        }
        
    }
    },
    beforeDestroy() {
        clearInterval(this._interval);
  },
    computed: {
      events() {
        return this.$store.state.contactEvents;
      },
      validateAddCustomerForm() {
        // return this.fname.length > 0;
        // return true
      },
    },
  
    components: {
      CustomizerSidebar,
    },
  
    mounted() {
        if(this.$moment.locale() == 'en') {
            this.$moment.locale('en-gb')
        }

        this._interval = setInterval(this.toggleDot, 2000);
    },
  };
  </script>
  <style scoped>
  .verified-icon {
    display: inline-block;
    font-size: 20px;
  }
  .mdi-check-circle {
    color: green;
  }
  .mdi-close-circle {
    color: red;
  }

  .pending-dot-red{
    width: 9px;
    height: 9px;
    border-radius: 100%;
    background-color: red;
    margin: auto;
    margin-right: 7px;
    -webkit-transition: background-color 2s ease-out;
  -moz-transition: background-color 2s ease-out;
  -o-transition: background-color 2s ease-out;
  transition: background-color 2s ease-out;
  }
  .pending-dot-white{
    background-color: white;
  }
  </style>
  